
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/layouts/Icon.vue';
import { TargetPerson } from './TargetPersonFormComponent.vue';

type UseDate = {
  useScheduleDateTime: string;
  price: number;
  subsidyPriceId: string;
};

export type CouponApplyDate = TargetPerson & {
  subsidyId: string;
  subsidyDetailId: string;
  usedFromDiv: string;
  priceType: '本人' | '家族';
  costUnderChargeableFlg: string;
  multipleUnusableFlg: string;
  minChargeAmt?: number;
  useDates: Array<UseDate>;
};

export type CouponApplyDateMaster = {
  useDateOptions: {
    useScheduleDateTime: string;
    price: number;
    subsidyPriceId: string;
  }[];
};

@Component({
  components: {
    Icon,
  },
  filters: {
    comma(value?: number) {
      if (!value) return 0;
      return value.toLocaleString();
    },
  },
})
export default class CouponApplyDateComponent extends Vue {
  @Prop({ type: Boolean, required: true })
  disabled!: boolean;

  @Prop({ type: Object, required: true })
  couponApplyDate!: CouponApplyDate;

  @Prop({ type: Object, required: true })
  couponApplyDateMaster!: CouponApplyDateMaster;

  clickDelete(): void {
    this.$emit('delete', this.couponApplyDate);
  }
}
